import clsx from 'clsx'
import React, {FC} from 'react'
import {Search} from './Search'

const toolbarButtonMarginClass = 'ms-1 ms-lg-3'

const Topbar: FC<any> = ({filter, setFilter}) => {
  return (
    <div className='d-flex align-items-stretch flex-shrink-0'>
      {/* Search */}
      <div className={clsx('d-flex align-items-stretch', toolbarButtonMarginClass)}>
        <Search filter={filter} setFilter={setFilter} />
      </div>
    </div>
  )
}

export {Topbar}
